import React, { useEffect, useState, useRef, useMemo } from 'react';

import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { Alert, Button, QRCode } from 'antd';
import { getQRCodeBankID } from '../../data/store/user/userActions';
import { ReactComponent as Telephone } from './img/telephone-dark.svg';

import { ReactComponent as Arrow } from '../../assets/arrow-up-right.svg';
import { API_URLS } from '../../constants/api_urls';
import { CLIENTS } from '../../constants/routes';
import { LOGIN_USER } from '../../data/store/user/userActionTypes';
import StorageService from '../../services/StorageService';
import SessionService from '../../services/SessionService';

import titleLogo from '../../assets/lt_logo.png';
import titleLogo_dark from '../../assets/lt_logo_dark.png';
import './style.scss';

const BankIDLogin = ({ remember, theme }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('');
  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const isLoading = useSelector((state) => state.userReducer.isLoading);
  const { codeBankID } = useSelector((state) => state.userReducer);
  const [intervalID, setIntervalID] = useState(null);
  const isCollectingRef = useRef(false);
  const offsetStart = useRef(null);

  const [codeQR, setCodeQR] = useState('');
  const [alert, setAlert] = useState('');

  // eslint-disable-next-line no-undef
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    console.log('codeQR', codeQR);
  }, [codeQR]);

  const diffTime = useMemo(() => {
    if (codeBankID?.before_time) {
      const diff = codeBankID.before_time - offsetStart.current;
      console.log('🚀 ~ code ~ diff:', diff);
      return diff;
    } else return 0;
  }, [offsetStart, codeBankID]);

  const getCode = () => {
    offsetStart.current = Date.now();
    console.log('🚀 ~ getCode ~ offsetStart:', offsetStart.current);
    dispatch(getQRCodeBankID());
  };

  useEffect(() => {
    getCode();
  }, []);

  useEffect(() => {
    if (codeBankID?.qrs?.length > 0) {
      renderCode();
    }
  }, [codeBankID]);

  useEffect(() => {
    return () => {
      if (intervalID) {
        clearInterval(intervalID);
      }
    };
  }, [intervalID]);

  const collect = async () => {
    const resp = await axios.get(`${baseUrl}${API_URLS.BANKID_LOGIN_COLLECT}`, {
      params: { order_ref: codeBankID.order_ref },
      withCredentials: true,
    });
    let data;
    resp.status === 200 ? (data = resp.data) : (data = resp.response.data);
    return data;
  };

  const stopCollect = async () => {
    const resp = await axios.post(`${baseUrl}${API_URLS.BANKID_CANCEL_COLLECT}`, {
      order_ref: codeBankID.order_ref,
    }, { withCredentials: true });
    return resp.data;
  };
  const stopInterval = (idInt) => {
    clearInterval(idInt);
  };
  const successAlert = (value) => {
    setAlert(value);
    setTimeout(() => {
      setAlert('');
    }, 3500);
  };

  const renderCode = () => {
    const idInt = setInterval(code, 1000);
    setIntervalID(idInt);

    async function code() {
      let startIndex = Math.floor(
        (Date.now() + diffTime - codeBankID.start_time) / 1000,
      );
      console.log(
        '🚀 ~ code ~ startInDate.now()- codeBankID.start_timedex:',
        Date.now() - codeBankID.start_time,
      );
      console.log('🚀 ~ code ~ startIndex:', startIndex);
      console.log(
        '🚀 ~ startIndex Old Method:',
        Math.floor((Date.now() - codeBankID.start_time) / 1000),
      );

      if (isCollectingRef.current) {
        console.log('⏳ Previous request is still in progress, skipping...');
        return;
      }

      if (startIndex > codeBankID.qrs?.length - 1) {
        dispatch({ type: 'CLEAR_QR_BANKID' });
        setIntervalID(null);
        stopInterval(idInt);
        setCodeQR('Try again');
        isCollectingRef.current = false;
      } else if (codeBankID?.qrs?.length) {
        isCollectingRef.current = true;
        const res = await collect();
        isCollectingRef.current = false;

        if (res?.hint_code === 'userSign') {
          setCodeQR('wait finger');
        } else if(res?.status === 'user_not_found') {
          dispatch({ type: 'CLEAR_QR_BANKID' });
          setIntervalID(null);
          stopInterval(idInt);
          setCodeQR('Try again. User not found');
          isCollectingRef.current = false;
        } else if (!res?.hint_code && res?.status === 'complete') {
          successAlert(res.completion_data.user.name);
          clearInterval(idInt);
          setIntervalID(null);
          setCodeQR('');
          if (res?.ID) {
            if (remember) {
              StorageService.setItem('acc', res.token);
              StorageService.setItem('rfr', res.expire);
            } else {
              SessionService.setItem('acc', res.token);
              SessionService.setItem('rfr', res.expire);
            }
            dispatch({ type: LOGIN_USER.SUCCESS, payload: res });
            if (res.role !== 'CLIENT') {
              history.push(CLIENTS);
            } else {
              history.push('/');
            }
          }
          dispatch({ type: 'CLEAR_QR_BANKID' });
        } else if (
          res.status === 400 ||
          res?.status === 'failed' ||
          res?.hint_code === 'startFailed'
        ) {
          clearInterval(idInt);
          setIntervalID(null);
          setCodeQR('Try again');
          dispatch({ type: 'CLEAR_QR_BANKID' });
          dispatch({ type: 'SET_ERROR', payload: res?.message || 'Error' });
        } else setCodeQR(codeBankID.qrs[startIndex]);
      }
    }
  };
  const closeBankID = () => {
    setCodeQR('');
    if (codeBankID?.order_ref) stopCollect();
    clearInterval(intervalID);
    dispatch({ type: 'CLEAR_QR_BANKID' });
    isCollectingRef.current = false;
    history.goBack();
  };

  return (
    <div className="login-form">
      {alert && <Alert message={`Success. ${alert} login`} type="success" />}
      <div className="login-form-title">
        <img
          src={theme !== 'dark-theme' ? titleLogo : titleLogo_dark}
          alt="title logo"
        />
      </div>
      <div style={{ width: '100%', minHeight: '200px' }}>
        {codeQR && codeQR.includes('bankid.') && (
          <>
            <div className="modal-bankId-header white">
              {t('MOBILEID_HEADER')}
            </div>
            <div className="modal-bankId-code-wrapper qrcode">
              {codeQR && <QRCode errorLevel="H" size={210} value={codeQR} />}
            </div>
            <div className="modal-bankId-link">
              <a href="#">{t('USE_BANKID')}</a>
              <Arrow />
            </div>
          </>
        )}
        {codeQR === 'Try again' && (
          <>
            <div className="modal-bankId-header">{t('THE_LOGIN_FAILED')}</div>
            <p className="modal-bankId-text">{t('LOGIN_FAILED_TEXT')}</p>
            <div className="modal-bankId-link">
              <button onClick={() => getCode()}>{t('TRY_AGAIN')}</button>
            </div>
          </>
        )}
        {codeQR === 'Try again. User not found' && (
          <>
            <div className="modal-bankId-header">{t('THE_LOGIN_FAILED')}</div>
            <p className="modal-bankId-text">{t('LOGIN_FAILED_NOT_FOUND')}</p>
            <div className="modal-bankId-link">
              <button onClick={() => getCode()}>{t('TRY_AGAIN')}</button>
            </div>
          </>
        )}
        {codeQR === 'wait finger' && (
          <>
            <div className="modal-bankId-header">{t('LOGIN_WITH_BANKID')}</div>
            <div
              className="modal-bankId-code-wrapper"
              style={{ opacity: theme !== 'dark-theme' ? 0.25 : 1 }}
            >
              <Telephone />
            </div>
            <p className="modal-bankId-text">{t('TYPE_YOUR_SECURITY')}</p>
          </>
        )}
      </div>
      <Button
        iconPosition="end"
        className={'modal-bankId-cancel w360'}
        onClick={closeBankID}
      >
        Cancel
      </Button>
    </div>
  );
};

export default BankIDLogin;

BankIDLogin.propTypes = {
  remember: PropTypes.bool,
  theme: PropTypes.string,
};
